module.exports = __webpack_public_path__ + "img/数据资源select.7c853ce9.svg";